export function faq() {

    let faqBlock = document.querySelectorAll('[data-faq]');

    faqBlock.forEach( function(block) {
        let elems = block.querySelectorAll('[data-faq-elem]');
        elems.forEach( function(item, index) {

            item.addEventListener('click', function() {
                if (item.classList.contains('is-active')) {

                    elems.forEach( function(elem) {
                        elem.classList.remove('is-active');
                    });

                } else {
                    elems.forEach( function(elem) {
                        elem.classList.remove('is-active');
                    });

                    item.classList.add('is-active');
                }

            });
        })
    });


    let faqSection = document.querySelector('.js-faqSection'),
        faqShowAll = document.querySelector('.js-faqShowAll');

    if (!faqShowAll) {
        return false;
    }

    faqShowAll.addEventListener('click', () => {
        faqSection.classList.add('is-active');
        faqShowAll.style.display = 'none';
    });

}
